import { action } from "typesafe-actions";

import { message } from "antd";

import { GatePayload } from "../common_types";

import { ExtendedReportPayload, ExtendedReportTypes } from "./types";

export const sendRequest = (params: ExtendedReportPayload & GatePayload) =>
  action(ExtendedReportTypes.SEND_REQUEST, params);

export const requestSuccess = () => {
  message.success("Success");
  return action(ExtendedReportTypes.SEND_SUCCESS);
};

export const requestFailure = (errorMessage: string) => {
  message.error(errorMessage);
  return action(ExtendedReportTypes.SEND_FAILURE);
};
